import { Sede } from '@components/contatti/sede/sede';
import { Tooltip } from '@components/contatti/tooltip/tooltip';
import { TooltipContent } from '@components/contatti/tooltip-content/tooltip-content';
import React, { useState } from 'react';

const initialTooltip = {
  show: false,
  x: 0,
  y: 0,
  content: ''
};

const MappingSediDesktop = ({ sedi }) => {
  const [tooltip, setTooltip] = useState(initialTooltip);

  return (
    <>
      {sedi?.map((sede) => (
        <Sede
          key={sede.info.citta}
          citta={sede.info.citta}
          x={sede.marker.coordinates.x}
          y={sede.marker.coordinates.y}
          onMouseLeave={() => setTooltip(initialTooltip)}
          onMouseEnter={() => {
            setTooltip({
              show: true,
              x: sede.tooltip.coordinates.x,
              y: sede.tooltip.coordinates.y,
              content: (
                <TooltipContent
                  indirizzo={sede.info.indirizzo}
                  cap={sede.info.cap}
                  phone={sede.info.phone}
                  // email={sede.info.email}
                  onBlur={() => setTooltip(initialTooltip)}
                  onMouseLeave={() => setTooltip(initialTooltip)}
                />
              )
            });
          }}
          onFocus={() => {
            setTooltip({
              show: true,
              x: sede.tooltip.coordinates.x,
              y: sede.tooltip.coordinates.y,
              content: (
                <TooltipContent
                  indirizzo={sede.info.indirizzo}
                  cap={sede.info.cap}
                  // email={sede.info.email}
                  phone={sede.info.phone}
                  onBlur={() => setTooltip(initialTooltip)}
                  onMouseLeave={() => setTooltip(initialTooltip)}
                />
              )
            });
          }}
        />
      ))}
      <Tooltip width="291" height="115" xshift={tooltip.x} yshift={tooltip.y} show={tooltip.show}>
        {tooltip.content}
      </Tooltip>
    </>
  );
};

MappingSediDesktop.displayName = 'Mapping Sedi Desktop';
export { MappingSediDesktop };
